export default {"src":"/_next/static/media/HeartAttacksCardiacArrests.9921a924.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};